import { hideDialog, refresher } from "../../redux/guest-slices/other.slice"
import { updateSpecialist } from "../../redux/admin-slices/specialist.slice"
import { VERIFY_SPECIALIST } from "../../utils/keywords"
import { useDispatch, useSelector } from "react-redux"
import Icons from "../../assets/js/Icons"

import {
  Button, CircularProgress, DialogActions, DialogContent,
  DialogTitle, IconButton, Paper, Typography
} from "@mui/material"

function Verify() {
  const dispatch = useDispatch()
  const { type, data, loadings } = useSelector(state => state.otherSlice)

  // Close dialog
  const handleClose = () => {
    dispatch(hideDialog())
  }

  // Handle update  
  const handleUpdate = () => {
    if (type === VERIFY_SPECIALIST) {
      dispatch(updateSpecialist({
        id: data?.specialistId,
        formData: { status: "verified" },
      })
      ).unwrap().then(() => {
        setTimeout(() => {
          handleClose()
          dispatch(refresher())
        }, 500)
      }).catch(() => { })
    }
  }

  return (
    <Paper>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            m: "0",
            fontSize: "24px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          {
            type === VERIFY_SPECIALIST ?
              "Specialist profile verification" :
              null
          }
        </Typography>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "other.color1",
            position: "absolute",
          }}
          size="small"
          onClick={handleClose}
        ><Icons.CancelSolid />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className="relative"
        sx={{ ".MuiInputBase-root": { borderRadius: "6px" } }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            textAlign: "center",
          }}
        >
          {
            type === VERIFY_SPECIALIST ?
              "Warning: Please ensure all documents have been thoroughly checked and meet verification criteria before approving the specialist. Are you sure you want to proceed?" :
              null
          }
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", px: 3 }}>
        <Button
          type="submit"
          color="success"
          variant="contained"
          onClick={handleUpdate}
          sx={{ minWidth: 120 }}
          endIcon={(
            loadings?.update
          ) &&
            <CircularProgress
              size={20}
              thickness={5}
              sx={{ color: "white" }}
            />
          }
        >Verify
        </Button>
      </DialogActions>
    </Paper>
  )
}

export default Verify